// Filter groups for the crm-search API

// Contacts who are marked as marketing
const isMarketable = {
  operator: 'IN',
  property: 'hs_marketable_status',
  values: ['true']
};
const hasNoMarketableStatusProperty = {
  operator: 'NOT_HAS_PROPERTY',
  property: 'hs_marketable_status'
};

// Contacts who are not marked as only marketing until renewal
const isNotMarketableUntilRenewal = {
  operator: 'IN',
  property: 'hs_marketable_until_renewal',
  values: ['false']
};
const hasNoMarketingUntilRenewalProperty = {
  operator: 'NOT_HAS_PROPERTY',
  property: 'hs_marketable_until_renewal'
};
const isBounced = {
  operator: 'HAS_PROPERTY',
  property: 'hs_email_hard_bounce_reason_enum'
};
const isNotBounced = {
  operator: 'NOT_HAS_PROPERTY',
  property: 'hs_email_hard_bounce_reason_enum'
};
const isUnsubscribed = {
  operator: 'EQ',
  property: 'hs_email_optout',
  value: 'true'
};

// Marketing contacts who both:
// have a bounced e-mail, and
// are not marked as only marketing until renewal
export const BOUNCED_FILTERS = [{
  filters: [isBounced, isMarketable, isNotMarketableUntilRenewal]
}, {
  filters: [isBounced, hasNoMarketableStatusProperty, isNotMarketableUntilRenewal]
}, {
  filters: [isBounced, hasNoMarketingUntilRenewalProperty]
}];

// Marketing contacts who both:
// have unsubscribed, and
// are not marked as only marketing until renewal
export const UNSUBSCRIBED_FILTERS = [{
  filters: [isUnsubscribed, isNotBounced, isMarketable, isNotMarketableUntilRenewal]
}, {
  filters: [isUnsubscribed, isNotBounced, hasNoMarketableStatusProperty, isNotMarketableUntilRenewal]
}, {
  filters: [isUnsubscribed, isNotBounced, hasNoMarketingUntilRenewalProperty]
}];

// Contacts who are marked as marketing
export const ELIGIBLE_FILTERS = [{
  filters: [isMarketable]
}, {
  filters: [hasNoMarketableStatusProperty]
}];

// Contacts who are still marked as marketing after a renewal
export const ELIGIBLE_AFTER_RENEWAL_FILTERS = [{
  filters: [isMarketable, isNotMarketableUntilRenewal]
}, {
  filters: [hasNoMarketableStatusProperty, isNotMarketableUntilRenewal]
}, {
  filters: [hasNoMarketingUntilRenewalProperty]
}];
export const ELIGIBLE_AFTER_SWITCH_TO_MC_FILTERS = [{
  filters: [isNotMarketableUntilRenewal]
}, {
  filters: [hasNoMarketingUntilRenewalProperty]
}];
export const LISTS = [{
  __custom: 'lists',
  filters: [{
    operator: 'IN',
    property: 'listMemberships.listId',
    values: []
  }, isMarketable]
}, {
  __custom: 'lists',
  filters: [{
    operator: 'IN',
    property: 'listMemberships.listId',
    values: []
  }, hasNoMarketableStatusProperty]
}];
export const SEARCH = [{
  __custom: 'search',
  filters: [isMarketable]
}, {
  __custom: 'search',
  filters: [hasNoMarketableStatusProperty]
}];